"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function noJitter(delay) {
    return delay;
}
exports.noJitter = noJitter;
//# sourceMappingURL=no.jitter.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/exponential-backoff/dist/jitter/no/no.jitter.js
// module id = 323
// module chunks = 88 89